<script>
  import InlineSvg from './elements/InlineSvg.svelte';
</script>

<div class="reader-empty-favorites">
  <p><InlineSvg src="/img/no-favorites.svg" /></p>
  <h3>No saved items yet</h3>
  <p>Click the heart icon to save your favorite sites.</p>
</div>

<style lang="scss">
  @import '../styles/mixins';

  .reader-empty-favorites {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    overflow: hidden;

    h3 {
      @include font-heading(Semibold);
      font-size: 24px;
      line-height: 33px;
      letter-spacing: -0.01em;
      color: var(--color-blue-gray--700);
      margin: 40px 0 7px;
    }

    p {
      @include font(Medium);
      font-size: 14px;
      line-height: 21px;
      color: var(--color-blue-gray--300);
    }
  }

  :global(.dark-mode) {
    .reader-empty-favorites {
      h3 {
        color: var(--color-blue-gray--150);
      }

      p {
        color: var(--color-blue-gray--400);
      }
    }
  }
</style>
